import { getElvarliStabilityAmelioration } from '../../../../services/amelioration/range/elvarli';

export default {
  DUPLICATE_SIDEPANELS: {
    options: {},
    statisticsLabel: 'duplicate_sidepanels',
    translationKey: 'POPUP_ALERT_DUPLICATE_SIDEPANEL',
  },
  HIGH_CABINET_UNSTABLE: {
    options: {
      priority: 4,
    },
    statisticsLabel: 'high_cabinet_unstable',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_HIGH_CABINET',
  },
  INSERTS_TOO_FEW: {
    options: {
      priority: 2,
    },
    statisticsLabel: 'inserts_too_few',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_ADD_PART',
  },
  STABILITY_ZONES_UNCOVERED_BROR: {
    options: {},
    statisticsLabel: 'stability_zones_uncovered',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_MISPLACED',
  },
  STABILITY_ZONES_UNCOVERED_IVAR: {
    options: {
      priority: 3,
    },
    statisticsLabel: 'stability_zones_uncovered',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_PLACEMENT',
  },
  STABILITY_ZONES_UNCOVERED_IVAR_LOW_SECTION: {
    options: {
      priority: 3,
    },
    statisticsLabel: 'stability_zones_uncovered_low_section',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_LOW_SECTION',
  },
  NOT_ENOUGH_BRACKETS_WITH_HOLES_FOR_CLOTHES_RAIL_ELVARLI: {
    options: {
      priority: 1,
    },
    statisticsLabel: 'not_enough_brackets_with_holes_for_clothes_rail',
    translationKey: 'CLOTHES_RAIL_ADJACENT',
  },
  SUSPENSION_RAIL_TOO_WIDE: {
    options: {
      showInstantly: true,
    },
    statisticsLabel: 'suspension_rail_too_wide',
    translationKey: 'POPUP_ALERT_SUSPENSION_RAIL',
  },
  WEIGHT_LIMIT_EXCEEDED: {
    options: {
      priority: 1,
    },
    statisticsLabel: 'weight_limit_exceeded',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_WEIGHT',
  },
  STABILITY_ZONES_UNCOVERED_ELVARLI: {
    options: {
      priority: 2,
    },
    statisticsLabel: 'stability_zones_uncovered_elvarli',
    translationKey: 'POPUP_ALERT_INVALID_CONFIG_PLACEMENT',
    getAmelioration: getElvarliStabilityAmelioration,
  },
};
